import { useAppSelector } from '@shared/store';
import { selectIsBillingEnabled } from '@entities/account';

export const useAccountCompanyIsBillingEnabled = () => {
  const isBillingEnabled = useAppSelector(selectIsBillingEnabled);

  return isBillingEnabled;
};
